function User2Dashboard() {
    /// <summary>
    /// Constructor for the User2Dashboard widget.
    /// This object provides JavaScript functions for the Widget.Dashboard.User2Dashboard component.
    /// It manages the assignment of users (or items) to dashboards via drag-and-drop
    /// and double-click interactions between a source list and a target list.
    /// <br/>
    /// The widget extends MSAssignment and adds specific behavior for:
    /// - Showing/hiding an "edit" checkbox when items are moved between lists
    /// - Persisting edit-permission changes via the VisualCoreService
    /// <br/>
    /// Author: AFU<br />
    /// Date: 25.8.2026<br />
    /// Copyright ©: EUDT GmbH 2026 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 25.8.2026                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// * - includes special functions for handling the extra items          *<br />
    /// **********************************************************************<br />
    /// </summary>

}

// Inherit from MSAssignment to reuse base assignment list functionality
// (filtering, manual updates, sorting, etc.)
User2Dashboard.prototype = new window.MSAssignment();

User2Dashboard.prototype.initSortable = function () {
    /// <summary>
    /// Initializes jQuery UI Sortable on the source and target lists, enabling
    /// drag-and-drop assignment of items between them.
    ///
    /// This method overrides the base MSAssignment.initSortable and adds:
    /// 1. Drag-and-drop handling: When an item is dragged from lstSource to lstTarget,
    ///    the ".edit" container and ".chb-edit" checkbox become visible, allowing the
    ///    user to grant/revoke edit permissions. When dragged back, they are hidden.
    /// 2. Double-click handling: Double-clicking an item triggers manualUpdate (moves
    ///    it to the other list) and toggles the edit checkbox visibility accordingly.
    /// 3. Edit checkbox click handling: When the ".chb-edit" checkbox is toggled,
    ///    the new edit-permission state is persisted to the server via VisualCoreService.
    ///
    /// Items with the CSS class "priority-blocked" cannot be dragged.
    /// On mobile devices, sortable is not initialized (returns true immediately).
    /// </summary>
    /// <returns type="Boolean">True if initialization succeeded, false on error.</returns>
    var me = this;
    try {
        if (me.error) { return false; }
        if (me.mobile) { return true; }

        // Initialize jQuery UI Sortable on both lists, allowing items to be
        // dragged between any elements with the CSS class "connect".
        me.visual.find("#lstSource,#lstTarget").sortable({
            connectWith: ".connect",
            tolerance: 'pointer', cursor: 'move', placeholder: "lstPlaceholder",
            cancel: ".priority-blocked",
            // The 'update' callback fires whenever the sort order changes or an
            // item is received from the connected list.
            update: function (e, ui) {

                // Notify base class about the manual sorting change
                me.manualSorting(e);

                // ui.sender is non-null only when the item was received from
                // the other list (i.e., it crossed between source and target).
                if (ui.sender !== null) {
                    if (typeof (ui.item[0].attributes["data-id"]) !== "undefined") {
                        var $item = $(ui.item[0]);
                        // ui.sender[0].id contains the ID of the originating list
                        // ("lstSource" or "lstTarget") from which the item was dragged.
                        var source = ui.sender[0].id;

                        // If the item came from the source list, it is now in the
                        // target list -> show the edit checkbox so the user can
                        // configure edit permissions for this assignment.
                        if (source === "lstSource") {
                            $item.find(".edit").show();
                            $item.find(".chb-edit").show();
                        } else {
                            // Item was moved back to source -> hide edit checkbox
                            $item.find(".edit").hide();
                            $item.find(".chb-edit").hide();
                        }
                        // Persist the assignment change to the server
                        me.update(ui.sender[0].id, ui.item[0].attributes["data-id"].value);


                    }
                }
                // re-evaluate blocking after every drag
                //me.applyPriorityTagBlocking();
            }
        }).disableSelection();

        // Double-click handler: Allows users to move an item between lists by
        // double-clicking instead of dragging. The source list is determined
        // BEFORE manualUpdate moves the item, so we can reliably detect direction.
        me.visual.find(".connect").off("dblclick", ".vc-list-item").on('dblclick', ".vc-list-item", function () {
            var $item = $(this);
            // Determine which list the item currently belongs to (before the move)
            var source = $item.parents(".connect").attr("id");
            // Show edit checkbox when moving from source to target,
            // hide it when moving back from target to source
            if (source === "lstSource") {
                $item.find(".edit").show();
                $item.find(".chb-edit").show();
            } else {
                $item.find(".edit").hide();
                $item.find(".chb-edit").hide();
            }
            // Perform the actual move (inherited from MSAssignment)
            return me.manualUpdate($item);
        });


        // Click handler for the edit-permission checkbox.
        // When the user checks or unchecks the ".chb-edit" checkbox on an assigned
        // item in the target list, this handler persists the change to the server.
        // The checkbox's data-id attribute holds the item's unique identifier.
        me.visual.find(".connect").off("click", ".chb-edit").on('click', ".chb-edit", function () {

            var id = $(this).data("id");
            var edit = $(this).is(":checked");

            // Call the server to update the edit-permission flag for this assignment.
            // Parameters: type=3 indicates an edit-permission update operation.
            window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, me.parameter, me.signalParameter, me.deviceType, me.langid, JSON.stringify({ 'type': 3, 'LoggerId': me.blid, 'id': id, 'assID': me.assID, 'edit': edit }),
                function (result) {
                    return true;
                });
        });


        return true;
    } catch (ex) {
        me.writeError('initSortable', ex);
        return false;
    }
};

User2Dashboard.prototype.loadItems = function (id) {
    /// <summary>
    /// Loads all available items for the given assignment ID from the server and
    /// populates the source and target sortable lists.
    ///
    /// Each item is rendered as an <li> element with:
    /// - CSS classes indicating state: "inactive", "notDelete", "staff"
    /// - A data-id attribute for identification during drag/drop operations
    /// - Optional icons (ban icon for non-deletable, users icon for staff items)
    /// - A prefix-name display format
    /// - An edit-permission checkbox (".chb-edit") wrapped in a ".edit" container
    ///
    /// Items with a non-null "foundid" are placed in lstTarget (already assigned),
    /// items with null "foundid" are placed in lstSource (available for assignment).
    ///
    /// After populating the lists, the edit checkboxes in the source list are hidden
    /// (they only become visible when an item is moved to the target list), and
    /// initSortable() is called to enable drag-and-drop.
    /// </summary>
    /// <param name="id" type="String|Number">The assignment ID to load items for.</param>
    /// <returns type="Boolean">True if the load was initiated, false on error.</returns>
    var me = this;
    var sTmp;
    try {
        if (me.error) { return false; }
        me.assID = id;
        // Show a loading indicator while the server request is in progress
        me.visual.find("#lstSource").html(me.vcC.getLoadingIcon());


        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, me.parameter, me.signalParameter, me.deviceType, me.langid, JSON.stringify({ 'type': 1, 'LoggerId': me.blid, 'id': id, 'assID': me.assID }),
            function (result) {

                if (result === null) {
                    me.showMessage(me.resources.err_loadData, true);
                    return false;
                }
                $("#" + me.visual[0].id + " #lstSource,#" + me.visual[0].id + " #lstTarget").html("");
                if (result.rows === null) {
                    $("#" + me.visual[0].id + " #lstSource").html("<div class='note' style='margin:0 3px 0 3px'>" + me.resources.noEntriesExist + "</div>");
                    return false;
                }

                // Build HTML for each item and append to the appropriate list
                for (var i = 0; i < result.rows.length; i++) {
                    sTmp = "<li class='vc-list-item ui-widget-content";
                    if (result.rows[i].active === false) { sTmp += " inactive" }


                    if (result.rows[i].delete === false) { sTmp += " notDelete" }

                    if (result.rows[i].staff === true) { sTmp += " staff" }
                    sTmp += "' data-id='" + result.rows[i].id + "'>";
                    sTmp += me.addAssignmentItemSpecifics(result.rows[i]);
                    if (result.rows[i].delete === false) { sTmp += "<i class='fa fa-ban'></i> " }
                    if (result.rows[i].staff) { sTmp += "<i class='fa fa-users'></i> " }

                    if (result.rows[i].prefix.length > 0) {
                        sTmp += result.rows[i].prefix + ' - ' + result.rows[i].name;
                    } else {
                        sTmp += result.rows[i].name;
                    }

                     // Add the edit-permission checkbox inside a ".edit" wrapper div.
                     // This checkbox allows toggling edit rights for the assigned item.
                     // It is initially hidden for items in lstSource and shown for items in lstTarget.
                     sTmp += "<div class='edit' style='float:right' ><input type='checkbox' data-id='" + result.rows[i].id + "' class='chb-edit' " + (result.rows[i].edit ? "checked='checked'" : "") + " />";


                    sTmp += "</li>";
                    if (result.rows[i].foundid === null) {
                        me.visual.find("#lstSource").append(sTmp);
                    } else {
                        me.visual.find("#lstTarget").append(sTmp);
                    }
                }
                // Hide the edit checkbox containers for all items in the source list.
                // The edit checkbox should only be visible for items that are assigned
                // (in the target list). It becomes visible when an item is moved to target.
                me.visual.find("#lstSource .edit").hide();

                me.initSortable();
                me.filter(me.visual.find("#divSource #txtFilter"), me.visual.find("#divSource"));
                me.filter(me.visual.find("#divTarget #txtFilter"), me.visual.find("#divTarget"));
                me.reportValid();
                return true;
            });

        return true;
    } catch (ex) {
        me.writeError('loadItems', ex);
        return false;
    }

};



